import * as React from 'react';
import {useFormikContext} from 'formik';
import FormContainer from '../../containers/FormContainer';
import {WebinarObject} from 'api/webinar/types';

/**
 * The save after form part
 * @return {React.ReactElement}
 * @constructor
 */
export default function SaveAfterForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<WebinarObject>>();

  /**
   * The change event handler.
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
    formContext.setFieldValue('saveAfter', event.target.checked);
    formContext.submitForm();
    console.log(event);
  }

  return (
    <FormContainer
      property="saveAfter"
      label="Сохранить запись после завершения библиотеке"
      onChange={handleChange}
      collapse
    />
  );
}
